<template>
    <div class="create-report-wrapper">
        <h1>Umfrage Report</h1>
        <div v-for="data in report" v-bind:key="data.question" style="width: 100%">
            <h3 align="center">{{data.question}}</h3>
            <div class="pie-wrapper">
                <div>
                    <div class="group-title">Testgruppe</div>
                    <BarChart v-if="!data.testGroup.hideChart" style="height: 80%; margin: auto; width: 27vw;"
                              :width="null"
                              :height="null"
                              :test_size="data.testGroup.test_size"
                              :labels="data.testGroup.labels"
                              :data-array="[{
              backgroundColor: ['#41525c','#ffa600','#b9ac02','#008c6f','#419b57','#7aa734','#007978','#2b6571' ],
              data: data.testGroup.data,
              borderWidth: 0
            }]">
                    </BarChart>
                    <div v-if="data.controlGroup.hideChart">Noch keine Daten</div>
                </div>
                <div>
                    <div class="group-title">Kontrollgruppe</div>
                    <BarChart v-if="!data.controlGroup.hideChart" style="height: 80%; margin: auto; width: 27vw;"
                              :width="null"
                              :height="null"
                              :test_size="data.controlGroup.test_size"
                              :labels="data.controlGroup.labels"
                              :data-array="[{
              backgroundColor: ['#41525c','#ffa600','#b9ac02','#008c6f','#419b57','#7aa734','#007978','#2b6571' ],
              data: data.controlGroup.data,
              borderWidth: 0
            }]">
                    </BarChart>
                    <div v-if="data.controlGroup.hideChart">Noch keine Daten</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {RepositoryFactory} from "../scripts/RepositoryFactory";

    const SurveysRepository = RepositoryFactory.get('surveys');

    import BarChart from "../components/BarChart";

    export default {
        name: "Report",
        components: {
            BarChart
        },
        data: function () {
            return {
                report: []
            }
        },
        computed: {},
        methods: {
            async getReport() {
                try {
                    const {data} = await SurveysRepository.getSurveyReport(this.$route.params.id);
                    for (let i = 0; i < data.length; i++) {
                        let votesTestGroup = [];
                        let votesControlGroup = [];
                        let res = data[i];
                        let hideChart = true;
                        for (let j = 0; j < res.answers.length; j++) {
                            if (res.answers[j].votesSawCreative > 0 || res.answers[j].votesNotSeenCreative > 0) {
                                hideChart = false;
                            }
                        }
                        let labels = [];
                        for (let j = 0; j < res.answers.length; j++) {
                            votesTestGroup.push(res.answers[j].votesSawCreative);
                            votesControlGroup.push(res.answers[j].votesNotSeenCreative);
                            labels.push(res.answers[j].answer);
                        }
                        this.report.push({
                            question: res.question,
                            testGroup: {
                                data: votesTestGroup,
                                labels: labels,
                                hideChart: hideChart,
                                test_size: res.test_size
                            },
                            controlGroup: {
                                data: votesControlGroup,
                                labels: labels,
                                hideChart: hideChart,
                                test_size: res.test_size
                            }
                        });
                    }
                } catch (e) {
                    this.$noty.error("Fehler beim Laden des Reports: \n" + e.response.data.error);
                }
            }
        },
        mounted() {
            console.log('mounted');
            this.getReport();
        }
    }
</script>
<style lang="scss" scoped>

    .create-report-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .pie-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }

    .pie-container {
        width: 45%;
        margin-bottom: 20px;
    }

    .group-title {
        text-align: center;
        margin-bottom: 10px;
    }

</style>